module.exports = __webpack_public_path__ + "static/Teilnahme-Screen-78594bd6ed2e947fb7f547d06db37867.png";